import React, { useState, useEffect } from 'react';

const ExcelViewer = () => {
  const [excelData, setExcelData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch data from the backend using fetch API
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/excel`)
      .then((response) => response.json())
      .then((data) => {
        setExcelData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching the Excel data:', error);
        setLoading(false);
      });
  }, []);

  const handleDownload = () => {
    // Trigger the file download using fetch
    fetch(`${process.env.REACT_APP_API_URL}/api/download/excel`)
      .then((response) => response.blob()) // Get the response as a Blob
      .then((blob) => {
        const url = window.URL.createObjectURL(blob); // Create a download link for the blob
        const link = document.createElement('a'); // Create an anchor element
        link.href = url;
        link.setAttribute('download', 'data.xlsx'); // Set the filename for download
        document.body.appendChild(link);
        link.click(); // Trigger the download
        document.body.removeChild(link); // Clean up the link element
      })
      .catch((error) => {
        console.error('Error downloading the file:', error);
      });
  };

  if (loading) return <div style={styles.loading}>Loading...</div>;

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Excel Data</h1>
      <button style={styles.button} onClick={handleDownload}>Download Excel</button>
      <table style={styles.table}>
        <thead>
          <tr>
            {excelData.length > 0 && Object.keys(excelData[0]).map((key) => (
              <th key={key} style={styles.th}>{key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {excelData.map((row, index) => (
            <tr key={index}>
              {Object.values(row).map((value, idx) => (
                <td key={idx} style={styles.td}>{value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Inline styles object
const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    margin: '20px',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  header: {
    textAlign: 'center',
    color: '#333',
    marginBottom: '20px',
  },
  button: {
    display: 'block',
    width: '200px',
    margin: '0 auto 20px',
    padding: '10px',
    backgroundColor: '#007bff',
    color: 'white',
    fontSize: '16px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  buttonHover: {
    backgroundColor: '#0056b3',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
  },
  th: {
    padding: '10px',
    textAlign: 'left',
    border: '1px solid #ddd',
    backgroundColor: '#f2f2f2',
  },
  td: {
    padding: '10px',
    textAlign: 'left',
    border: '1px solid #ddd',
  },
  trEven: {
    backgroundColor: '#f9f9f9',
  },
  trHover: {
    backgroundColor: '#f1f1f1',
  },
  loading: {
    textAlign: 'center',
    fontSize: '18px',
    color: '#007bff',
  },
};

export default ExcelViewer;

